import { render, staticRenderFns } from "./GFileResultItem.vue?vue&type=template&id=611148fc&"
import script from "./GFileResultItem.vue?vue&type=script&lang=js&"
export * from "./GFileResultItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports